/* eslint-disable camelcase */
import { init, AuthType } from '@thoughtspot/visual-embed-sdk';
import { getTokenService, getHost } from './tokenService';

export const authenticate = async (): Promise<void> => {
  try {
    await init({
      thoughtSpotHost: getHost(),
      authType: AuthType.TrustedAuthTokenCookieless,
      getAuthToken: getTokenService,
      autoLogin: true,
      disableTokenVerification: true,
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Authentication failed:', error);
    throw new Error('Failed to initialize authentication');
  }
};
